<div class="p-relative flex justify-between">
    <h4 mat-dialog-title>Редактирование прайса</h4>
    <app-close-button [formGroup]="priceForm" [dialogRef]="dialogRef"/>
</div>
<mat-dialog-content>
    @if (loading()) {
        <app-loader [isLoading]="loading()"/>
    } @else {
        <form class="flex-column" [formGroup]="priceForm" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="fill">
                <mat-label>Стоимость работ, руб.</mat-label>
                <input matInput type="number" formControlName="price" min="0"/>
                @if (priceForm.get('price')?.invalid) {
                    <mat-error>Стоимость работ должна быть положительной или равна нулю</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Стоимость работ со скидкой, руб.</mat-label>
                <input matInput type="number" formControlName="discountPrice" min="0"/>
                @if (priceForm.get('discountPrice')?.invalid) {
                    <mat-error>Стоимость не может быть отрицательной</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Длительность работ, мин.</mat-label>
                <input matInput type="number" formControlName="duration" min="0"/>
                @if (priceForm.get('duration')?.invalid) {
                    <mat-error>Длительность работ должна быть положительной или равна нулю</mat-error>
                }
            </mat-form-field>

            <app-common-dropdown [label]="'Категория'" [service]="categorySelectorService" [formCtrl]="priceForm.controls.categoryId"/>
            <app-common-dropdown [label]="'Работа'" [service]="workSelectorService" [formCtrl]="priceForm.controls.workId"/>
            @if (canUsePaymentDevice) {
                <app-common-dropdown
                    [label]="'Позиция в кассе'"
                    [service]="externalPriceSelectorService"
                    [formCtrl]="priceForm.controls.externalPriceId"
                    [searchBy]="'name'"
                />
            }

            <div class="flex justify-between">
                <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!price.data.id" (click)="deletePrice(price.data.id)">Удалить</button>
                <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!priceForm.valid">Сохранить</button>
            </div>

        </form>
    }
</mat-dialog-content>
